import {
  FormControl, FormErrorMessage,
  Radio,
  RadioGroup
} from '@chakra-ui/react'
import type { WizardPropertyAdditionalData } from 'BrokerTsLib/src/dtos'
import { Selection, SelectionType } from 'BrokerTsLib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import { useContext } from 'react'

import { FormGroup } from '../../components/FormGroup'
import { FormLabel } from '../../components/FormLabel'
import { InputGroup } from '../../components/InputGroup'
import { RadioStack } from '../../components/RadioStack'
import { useSelections } from '../../hooks'
import { insuranceParamsContext } from '../../layouts/Wizard'

export const AdditionalPropertyInfoCpp = () => {
  const { insuranceParams } = useContext(insuranceParamsContext)

  const { data: dataStavRekonstrukce } = useSelections(SelectionType.StavRekonstrukce)

  const isContracted = !!insuranceParams?.generalParams.contractNumber
  const { register, watch, formState: { errors }, getFieldState, setValue, getValues } = useFormContext<WizardPropertyAdditionalData>()

  const mainBuildingRequired = getValues('property.additionalDataCpp.mainBuildingRequired')
  const secondaryBuildingRequired = getValues('property.additionalDataCpp.secondaryBuildingRequired')
  const secondaryBuildingsAreaRequired = getValues('property.additionalDataCpp.secondaryBuildingsAreaRequired')
  const realtyInNewPriceRequired = getValues('property.additionalDataCpp.realtyInNewPriceRequired')
  const reconstractionStateRequired = getValues('property.additionalDataCpp.reconstractionStateRequired')

  const stavRekonstrukceId = watch('property.additionalDataCpp.reconstractionStateId')

  return (
    <>
      {mainBuildingRequired &&
        <FormControl isRequired isInvalid={!!errors.property?.additionalDataCpp?.mainBuilding}>
          <FormLabel>Hlavní stavba</FormLabel>
          <InputGroup
            isDisabled={isContracted}
            id="mainBuilding"
            htmlSize={30}
            autoComplete="off"
            errors={errors.property?.additionalDataCpp?.mainBuilding}
            {...register('property.additionalDataCpp.mainBuilding')}
          />
        </FormControl>
      }

      {(secondaryBuildingRequired || secondaryBuildingsAreaRequired) &&
        <FormGroup>
          {secondaryBuildingRequired &&
            <FormControl isRequired isInvalid={!!errors.property?.additionalDataCpp?.secondaryBuilding}>
              <FormLabel>Vedlejší stavba</FormLabel>
              <InputGroup
                isDisabled={isContracted}
                id="secondaryBuilding"
                //htmlSize={8}
                autoComplete="off"
                errors={errors.property?.additionalDataCpp?.secondaryBuilding}
                {...register('property.additionalDataCpp.secondaryBuilding')}
              />
            </FormControl>
          }
          {secondaryBuildingsAreaRequired &&
            <FormControl isRequired isInvalid={!!errors.property?.additionalDataCpp?.secondaryBuildingsArea}>
              <FormLabel>Plocha vedlejších staveb</FormLabel>
              <InputGroup
                isDisabled={isContracted}
                id="secondaryBuildingsArea"
                //htmlSize={8}
                autoComplete="off"
                inputMode="decimal"
                errors={errors.property?.additionalDataCpp?.secondaryBuildingsArea}
                {...register('property.additionalDataCpp.secondaryBuildingsArea')}
              />
            </FormControl>
          }
        </FormGroup>

      }
      {realtyInNewPriceRequired &&
        <FormControl isRequired isInvalid={!!errors.property?.additionalDataCpp?.realtyInNewPrice}>
          <FormLabel>Pojištění bytové jednotky na cenu</FormLabel>

          <RadioGroup
            isDisabled={isContracted}
            value={watch('property.additionalDataCpp.realtyInNewPrice') == true ? 'true' : 'false'}
            onChange={(val) => setValue('property.additionalDataCpp.realtyInNewPrice', val === 'true')}
          >
            <RadioStack variant="stackedTile">
              <Radio value="false">Obvyklou</Radio>
              <Radio value="true">Novou</Radio>
            </RadioStack>
          </RadioGroup>

          {errors.property?.additionalDataCpp?.realtyInNewPrice && <FormErrorMessage>{errors.property?.additionalDataCpp?.realtyInNewPrice?.message}</FormErrorMessage>}
        </FormControl>
      }

      {reconstractionStateRequired &&
        <FormGroup>
          <FormControl isRequired isInvalid={!!errors.property?.additionalDataCpp?.reconstractionStateId}>
            <FormLabel tooltip='Vyberte, zda v objektu proběhla či probíhá rekonstrukce'>Rekonstrukce</FormLabel>

            <RadioGroup
              isDisabled={isContracted}
              onChange={x => setValue('property.additionalDataCpp.reconstractionStateId', parseInt(x))}
              value={stavRekonstrukceId?.toString()}
            >
              <RadioStack variant="stackedTile">
                {dataStavRekonstrukce?.sort((a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)).map((item) => (
                  <Radio value={item.id.toString()} key={item.id.toString()}>
                    {item.description}
                  </Radio>
                ))}
              </RadioStack>
            </RadioGroup>
            {errors.property?.additionalDataCpp?.reconstractionStateId && <FormErrorMessage>{errors.property?.additionalDataCpp?.reconstractionStateId.message}</FormErrorMessage>}
          </FormControl>

          {stavRekonstrukceId && stavRekonstrukceId == Selection.RekonstrukceCelkova &&
            <FormControl isInvalid={!!errors.property?.additionalDataCpp?.reconstractionYear}>
              <FormLabel>Rok poslední rekonstrukce</FormLabel>
              <InputGroup
                isDisabled={isContracted}
                id="reconstructionYear"
                //htmlSize={8}
                autoComplete="off"
                inputMode="decimal"
                errors={errors.property?.additionalDataCpp?.reconstractionYear}
                {...register('property.additionalDataCpp.reconstractionYear')}
              />
            </FormControl>
          }
        </FormGroup>
      }
    </>
  )
}
